<template>
  <vehicle-table :company-id="companyId" class="mt-3" />
</template>
<script>
import VehicleTable from '../../../../../components/VehicleTable.vue';

export default {
  name: 'company_vehicle_list',
  components: {
    VehicleTable,
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
  },
  created() {
    this.$store.dispatch('companies/LOAD_DETAIL_DATA');
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/admin/companies/detail/Vehicles.vue